export default __webpack_public_path__ + "static/media/MotherBoardImg.db6a9d67.jpg";